module.exports = __webpack_public_path__ + "static/media/arrow-up.73e739a4.svg";